// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"4811ae2d","338":"8a2295f3","541":"5a022a65","544":"16e1bedc","576":"a9b4fd8c","753":"0c3a9a95","775":"913ba342","823":"1cd8a3a1","990":"9415e0a0"}[chunkId] + ".js";
};